import Type from '../../../redux/actions'

const caseDetail = (
  state = {
    // litigation: {},
    // executive: {},
    // litiPrsv: {},
    // mediation: {},
    // repaymentNegoList: {},
    // jude: {},
    // globalVariable: {}
  },
  action
) => {
  switch (action.type) {
    case Type.SET_DETAIL:
      return {
        ...state,
        [action.systemNum]: {
          ...state[action.systemNum],
          [action.cardType]: action.content,
        }
      };
    case Type.RESET_DETAIL:
      const newState = { ...state }
      delete newState?.[action.systemNum]

      return {
        // ...state,
        // [action.systemNum]: {}
        ...newState
      };
    case Type.SET_EXTRA_MEDIATION:
      return {
        ...state,
        [action.systemNum]: {
          ...state[action.systemNum],
          [action.cardType]: {
            ...state[action.systemNum][action.cardType],
            [action.name]: action.value
          }
        }
      };
    case Type.GLOBAL_VARIABLE:
      return {
        ...state,
        [action.systemNum]: {
          ...state[action.systemNum],
          globalVariable: {
            ...state[action.systemNum]?.globalVariable,
            [action.varType]: action.value
          }
        }
      };
    case Type.SET_REGISTRATION:
      return {
        ...state,
        [action.systemNum]: {
          ...state[action.systemNum],
          registration: action.data,
          regType: action.regType

        }
      };

    case Type.SET_LOSTPROVIDERTYPEDICT:
      return {
        ...state,
        [action.systemNum]: {
          ...state[action.systemNum],
          lostProviderTypeDict:action.payload
        }
      }
    default:
      return state
  }
}

export default caseDetail
